/* PetalHush P-062: upsells under the studio buy box (sections/ph-upsell.liquid). No dependencies.
   Talks to the buy box (sections/ph-breed-product.liquid + assets/petalhush-breed.js) only through its DOM:
   - U1 "Choose" = a real click on the buy box's Material radio (input[name="id"][data-metal=…]), so the buy box's own
     change handler runs exactly as when the customer taps the card there: price, compare-at, total, variant id, slide 1
     image, swipe-card state, ?variant= URL. Photo / text fields are not touched by that handler. Then the material
     row scrolls back into view and focus goes to the checked radio. Cards follow every material change (change event).
   - U2 "Make it two" = the form's quantity input (hidden, value 1 by default) set to 2 + a change event; petalhush-breed.js
     (P-062 patch) multiplies the total and posts the add-on fee lines with the same quantity. A confirmation with
     "Back to one" is placed above the buy box's Total row while the quantity is 2.
   - Prices: data-price (cents) of the buy-box radios, formatted with the shop's money format.
   - Free-shipping threshold: data-thr (theme setting, cents); with data-thr-src="fallback" the footer cart note
     (#ph-cart-note-config) wins when it is on the page. */
(function () {
  if (window.PetalHushUpsell) return;
  window.PetalHushUpsell = true;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents, format) {   // same as petalhush-breed.js (money_without_trailing_zeros)
    var n = cents / 100, whole = Math.round(n) === n;
    var f = format || '${{amount}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      var v = whole ? String(n) : n.toFixed(2);
      if (k.indexOf('comma') !== -1) v = v.replace('.', ',');
      return v.replace(/\B(?=(\d{3})+(?!\d))/g, k.indexOf('comma') !== -1 ? '.' : ',');
    });
  }
  function buy() { return document.querySelector('[data-ph-breed]'); }
  function form() { var b = buy(); return b ? b.querySelector('form[data-ph-form], form.ph-bform') : null; }
  function radios() { var b = buy(); return b ? Array.prototype.slice.call(b.querySelectorAll('input[name="id"]')) : []; }
  function checked() { var r = radios(); return r.filter(function (x) { return x.checked; })[0] || null; }
  function qtyInput(create) {
    var f = form(); if (!f) return null;
    var q = f.querySelector('input[name="quantity"]');
    if (!q && create) { q = document.createElement('input'); q.type = 'hidden'; q.name = 'quantity'; q.value = '1'; f.appendChild(q); }
    return q;
  }
  function qty() { var q = qtyInput(false); var n = q ? parseInt(q.value, 10) : 1; return n > 0 ? n : 1; }
  function topOffset() {   // sticky / fixed header height, if any
    var h = 0;
    Array.prototype.forEach.call(document.querySelectorAll('header, .shopify-section-group-header-group, sticky-header, header-component'), function (el) {
      var p = getComputedStyle(el).position, r = el.getBoundingClientRect();
      if ((p === 'sticky' || p === 'fixed') && r.top <= 1 && r.bottom > h) h = r.bottom;
    });
    return Math.min(h, 160) + 16;
  }
  function scrollTo(el, center) {
    if (!el) return;
    var r = el.getBoundingClientRect(), y = window.pageYOffset + r.top - topOffset();
    if (center) y = window.pageYOffset + r.top - Math.max(topOffset(), (window.innerHeight - r.height) / 2);
    window.scrollTo({ top: Math.max(0, y), behavior: reduced ? 'auto' : 'smooth' });
  }

  function init(root) {
    if (root.dataset.phUpsReady) return;
    root.dataset.phUpsReady = '1';
    var FMT = root.getAttribute('data-money') || '${{amount}}';
    var live = root.querySelector('[data-ph-ups-live]');
    var thr = parseInt(root.getAttribute('data-thr'), 10) || 10000;
    var shipOk = root.getAttribute('data-ship-ok') !== 'false';
    if (root.getAttribute('data-thr-src') === 'fallback') {
      try {
        var cn = document.getElementById('ph-cart-note-config');
        var c = cn ? JSON.parse(cn.textContent) : null;
        if (c && c.threshold > 0) thr = c.threshold;
      } catch (e) { /* keep the fallback */ }
    }
    function say(t) { if (!live || !t) return; live.textContent = ''; setTimeout(function () { live.textContent = t; }, 60); }

    /* ---------- U1 metal cards ---------- */
    var metal = root.querySelector('[data-ph-ups-metal]');
    function paintCards() {
      if (!metal) return;
      var m = checked(), cur = m ? String(m.value) : '';
      Array.prototype.forEach.call(metal.querySelectorAll('[data-ph-ups-card]'), function (card) {
        var on = card.getAttribute('data-variant') === cur, btn = card.querySelector('[data-ph-ups-choose]');
        card.classList.toggle('is-sel', on);
        if (on) card.setAttribute('aria-current', 'true'); else card.removeAttribute('aria-current');
        if (btn) {
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          btn.setAttribute('aria-label', on ? btn.getAttribute('data-aria-sel') : btn.getAttribute('data-aria'));
          btn.textContent = on ? metal.getAttribute('data-sel-label') : metal.getAttribute('data-choose-label');
        }
      });
    }
    if (metal) metal.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ph-ups-choose]'); if (!btn) return;
      var card = btn.closest('[data-ph-ups-card]'), err = metal.querySelector('[data-ph-ups-err]');
      var id = card.getAttribute('data-variant'), name = card.getAttribute('data-metal');
      var r = radios().filter(function (x) { return String(x.value) === id; })[0]
           || radios().filter(function (x) { return x.getAttribute('data-metal') === name; })[0];
      if (!r || r.disabled) { if (err) err.hidden = false; return; }
      if (err) err.hidden = true;
      if (!r.checked) r.click();   // the buy box's own path: checks it and fires input + change
      paintCards();
      var row = r.closest('.ph-mrow'), pill = r.closest('label');
      if (row && pill && row.scrollWidth > row.clientWidth) row.scrollTo({ left: Math.max(0, pill.offsetLeft - row.offsetLeft - 22), behavior: reduced ? 'auto' : 'smooth' });
      scrollTo(r.closest('fieldset') || r.closest('.ph-buy'));
      try { r.focus({ preventScroll: true }); } catch (x) { r.focus(); }
      say(String(metal.getAttribute('data-switched') || '').replace('{material}', name));
    });

    /* ---------- U2 one for each of you ---------- */
    var two = root.querySelector('[data-ph-ups-two]'), confirmEl = null;
    function paintTwo() {
      if (!two) return;
      var m = checked(); if (!m) return;
      var p = +m.getAttribute('data-price') || 0;
      var sum = 2 * p;   // QA fix 2: no struck compare-at on the "for two" total (not a two-piece deal)
      var line = shipOk && sum >= thr && two.getAttribute('data-ship') ? two.getAttribute('data-ship') : two.getAttribute('data-line');
      var tot = '<span class="ph-ups-sum" data-ph-ups-sum>' + esc(money(sum, FMT)) + '</span>';
      var e = esc(line || '');
      var el = two.querySelector('[data-ph-ups-total]');
      if (el) el.innerHTML = e.indexOf('{total}') !== -1 ? e.replace('{total}', tot) : tot + ' ' + e;
    }
    function ensureConfirm() {
      if (confirmEl && document.body.contains(confirmEl)) return confirmEl;
      var t = two && two.querySelector('template[data-ph-ups-confirm]'), f = form();
      if (!t || !f) return null;
      var ex = f.querySelector('[data-ph-upq]');   // theme editor: a re-rendered section reuses the one already placed
      if (ex) { confirmEl = ex; return ex; }
      var anchor = f.querySelector('.ph-total') || f.querySelector('[data-ph-add]');
      if (!anchor) return null;
      var frag = t.content ? t.content.cloneNode(true) : null;
      if (!frag) return null;
      confirmEl = frag.querySelector('[data-ph-upq]');
      anchor.parentNode.insertBefore(confirmEl, anchor);
      return confirmEl;
    }
    function paintQty() {
      if (!two) return;
      var n = qty(), on = n >= 2;
      var btn = two.querySelector('[data-ph-ups-make2]'), st = two.querySelector('[data-ph-ups-on]');
      if (btn) btn.hidden = on;
      if (st) st.hidden = !on;
      var ce = on ? ensureConfirm() : confirmEl;
      if (ce) ce.hidden = !on;
    }
    function setQty(n) {
      var q = qtyInput(true), err = two.querySelector('[data-ph-ups-err]');
      if (!q) { if (err) err.hidden = false; return false; }
      if (err) err.hidden = true;
      if (two.getAttribute('data-each')) q.setAttribute('data-ph-each', two.getAttribute('data-each'));   // "+$9 each" (petalhush-breed.js)
      q.value = String(n);
      q.dispatchEvent(new Event('change', { bubbles: true }));
      paintQty();
      return true;
    }
    if (two) {
      two.addEventListener('click', function (e) {
        if (e.target.closest('[data-ph-ups-make2]')) {
          if (!setQty(2)) return;
          var ce = ensureConfirm();
          scrollTo(ce || form(), true);
          if (ce) { try { ce.focus({ preventScroll: true }); } catch (x) { ce.focus(); } }
          say(two.getAttribute('data-active'));
        } else if (e.target.closest('[data-ph-ups-undo]')) {
          if (setQty(1)) { say(two.getAttribute('data-undone')); var b = two.querySelector('[data-ph-ups-make2]'); if (b) b.focus(); }
        }
      });
      document.addEventListener('click', function (e) {   // "Back to one" in the buy box
        var u = e.target.closest('[data-ph-upq] [data-ph-ups-undo]'); if (!u) return;
        if (setQty(1)) {
          say(two.getAttribute('data-undone'));
          var add = form() && form().querySelector('[data-ph-add]'); if (add) add.focus();
        }
      });
    }

    /* ---------- follow the buy box ---------- */
    document.addEventListener('change', function (e) {
      var t = e.target; if (!t || !t.matches) return;
      if (t.matches('[data-ph-breed] input[name="id"]')) { paintCards(); paintTwo(); }
      if (t.matches('[data-ph-breed] input[name="quantity"]')) paintQty();
    });
    paintCards(); paintTwo(); paintQty();
  }

  function boot(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ph-ups]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
